import classNames from 'classnames';
import { ReactElement } from 'react';
import { Input } from '../Input/Input';

import styles from './Spinner.module.scss';

type Props = {
  onChange: (value: number) => void;
  value: number;
  className?: string;
  children: ReactElement<typeof Input>;
  min?: number;
  max?: number;
};

export function Spinner(props: Props) {
  const { children, onChange, value, className, min, max } = props;
  const isAtMax = typeof max === 'number' && value >= max;
  const isAtMin = typeof min === 'number' && value <= min;

  return (
    <div className={classNames(styles.root, className)}>
      {children}
      <div className={styles.buttons}>
        <button
          type="button"
          className={styles.button}
          disabled={isAtMax}
          aria-label="Increase quantity"
          onClick={() => {
            if (isAtMax) {
              return;
            }
            onChange(value + 1);
          }}
        >
          +
        </button>
        <button
          type="button"
          className={styles.button}
          disabled={isAtMin}
          aria-label="Decrease quantity"
          onClick={() => {
            if (isAtMin) {
              return;
            }
            onChange(value - 1);
          }}
        >
          -
        </button>
      </div>
    </div>
  );
}
